
  import {prepareApiUrl} from '@/helper/UrlHelper';
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    name: 'LoggedUserMobileMenuDialog',
    components: {
      ExtrasNavigation: () => import('@/components/ExtrasNavigation'),
      JobsNavigation: () => import('@/components/JobsNavigation'),
      LoggedUserNavigation: () => import('@/components/LoggedUserNavigation'),
      ProfileFormNavigation: () =>
        import('@/components/candidate/ProfileFormNavigation'),
      AccountNavigation: () =>
        import('@/components/candidate/AccountNavigation'),
    },
    mixins: [ScreenSize],
    data() {
      return {
        tabs: null,
        value: 'recent',
        dialog: false,
        page: null,
      };
    },
    computed: {
      profileImagePortrait() {
        return this.$auth.user.candidateProfile.profileImagePortrait;
      },
      profileImageUrl() {
        return prepareApiUrl(
          process.env.NUXT_ENV_API_PROFILE_IMAGES_FILE_ENDPOINT,
          {
            routeParameters: {
              id: this.$auth.user.candidateProfile.profileImagePortrait.id,
            },
            getParameters: {filter: 'thumbnail'},
          }
        );
      },
    },
    methods: {
      handleDialog(on, page) {
        return ($event) => {
          if (this.dialog === true && this.page === page) {
            this.closeDialog();
          }

          if (!this.dialog) {
            on.click($event);
          }
          this.page = page;
        };
      },
      closeDialog() {
        this.dialog = false;
      },
    },
  };
